import { MAX_BATCH_ITEMS } from "../../lib/batch";

export function clampDelegateQuantity(value: number): number {
  if (!Number.isFinite(value)) return 1;
  return Math.max(1, Math.min(MAX_BATCH_ITEMS, Math.trunc(value)));
}

export function resizeDelegateRecipients(recipients: string[], quantity: number, clearExisting = false): string[] {
  const nextQuantity = clampDelegateQuantity(quantity);
  if (clearExisting) return Array.from({ length: nextQuantity }, () => "");
  return Array.from({ length: nextQuantity }, (_, index) => recipients[index] ?? "");
}
